import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=659083e1&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=ts&"
export * from "./Registration.vue?vue&type=script&lang=ts&"
import style0 from "./Registration.vue?vue&type=style&index=0&id=659083e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659083e1",
  null
  
)

export default component.exports